import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { ComponentPropsWithoutRef } from "react";

import { VideoClipConfirmCloseDialogComponent } from "./VideoClipConfirmCloseDialogComponent";

const CompassModal = ModalManager.create(
  (
    props: Omit<
      ComponentPropsWithoutRef<typeof VideoClipConfirmCloseDialogComponent>,
      "open" | "onOpenChange"
    >,
  ) => {
    const modal = useModal();

    return (
      <VideoClipConfirmCloseDialogComponent
        {...props}
        open={modal.visible}
        onOpenChange={open => {
          if (!open) {
            void modal.hide();
          }
        }}
      />
    );
  },
);

export const useVideoClipConfirmCloseDialog = () => useModal(CompassModal);
